module.exports = __webpack_public_path__ + "static/media/spinner.b6179604.svg";